import { Component, OnInit } from "@angular/core";
import { DateAdapter } from "@angular/material/core";
import { ActivatedRoute, Router } from "@angular/router";
import {
  AlertController,
  LoadingController,
  NavController,
} from "@ionic/angular";
import { Storage } from "@ionic/storage";
import { STORAGE } from "src/app/constant/storages";
import { _getStorage, _setStorage } from "src/app/utils/local-storage";
import { ApiserviceService } from "../../../app/httpservice/apiservice.service";
import { AppService } from "../../../app/services/app.service";
import { DateFormat } from "../report/setdate";
import { CN_DROPDOWN, listPriority_CN } from "./constant";
var moment = require("moment");
@Component({
  selector: "app-credit-note",
  templateUrl: "./credit-note.component.html",
  styleUrls: ["./credit-note.component.scss"],
  providers: [{ provide: DateAdapter, useClass: DateFormat }],
})
export class CreditNoteComponent implements OnInit {
  data = {
    name: "tong",
  };

  taxNumber: any = "";
  identityNumber: any = "";
  reasonCN: string = "";
  remark: string = "";
  tpno: string = "0";
  Active = 3;
  alert: any;
  receiptDate: Date = new Date();
  today: Date = new Date();

  creditNoteReasons: any = [];
  userID = "";
  userBu = "";
  userLoc = "";
  userRole = "";
  userSource = "";

  constructor(
    public router: Router,
    public navCtrl: NavController,
    public apiservice: ApiserviceService,
    public loadingController: LoadingController,
    public alertCtrl: AlertController,
    public appService: AppService,
    public storage: Storage,
    private route: ActivatedRoute,
    private dateAdapter: DateAdapter<Date>
  ) {}

  ngOnInit() {
    _setStorage(STORAGE.searchCreditNode, null);
    _setStorage(STORAGE.verifyCreditNote, null);
    _setStorage(STORAGE.confirmCreditNote, null);
    _setStorage(STORAGE.viewDataIndx, null);
    _setStorage(STORAGE.listdataCreditnote, null);
    this.userID = _getStorage(STORAGE.userID);
    this.userRole = _getStorage(STORAGE.userRole);
    this.userBu = _getStorage(STORAGE.userBu);
    this.userLoc = _getStorage(STORAGE.userLoc);
    this.userSource = _getStorage(STORAGE.SOURCE_SYSTEM);
    this.dateAdapter.setLocale("en-GB");

    window.localStorage.pageName = "";
    window.localStorage.isOldAbb = "";
  }
  ionViewDidEnter() {
    this.route.queryParams.subscribe((params) => {
      if (params.noName === "no_cn") {
        this.Active = Number(params.selectedIndex);
      } else {
        this.Active = 3;
      }
    });
  }

  ionViewWillEnter() {
    this.taxNumber = "";
    this.identityNumber = "";
    this.reasonCN = "";

    this.getConfigurationData();
  }

  async refresh() {
    const loading = await this.loadingController.create({
      cssClass: "my-custom-class",
      message: "Please refresh...",
    });
    await loading.present();
    setTimeout(() => {
      this.taxNumber = "";
      this.identityNumber = "";
      this.reasonCN = "";
      loading.dismiss();
    }, 1000);
  }

  searchCreditNote2() {
    this.router.navigate(["/credit-note-tax-list"]);
  }

  async getConfigurationData() {
    this.creditNoteReasons = CN_DROPDOWN;
  }

  async searchCreditNote() {
    let tpno: any;
    let validateResult = this.validateSearchField();
    if (!validateResult.status) {
      return await this.manualAlert(validateResult.message);
    }
    let temp_no: any;
    let taxNumber: any;
    if (this.taxNumber.indexOf("-") > -1) {
      temp_no = this.taxNumber.split("-");
      // console.log('temp_no', temp_no);
      taxNumber = temp_no[0] + "-" + temp_no[1].padStart(6, "0");
    } else {
      taxNumber = this.taxNumber;
    }

    let _reqBody = {
      cn_tax_receipt: taxNumber,
      cn_cid: this.identityNumber,
      cn_reason: this.reasonCN,
      cn_remark: this.remark,
      user_id: this.userID,
      user_bu: this.userBu,
      userSource: this.userSource,
      user_role: "",
      user_loc: this.userLoc,
      user_module: "",
      tpno: this.tpno === "0" ? true : false,
      cn_mode: "",
      company_name: "",
      receipt_date: this.receiptDate
        ? moment(this.receiptDate).format("YYYY-MM-DD")
        : moment().format("YYYY-MM-DD"),
    };

    console.log("[searchCreditNote] _reqBody : ", _reqBody);
    try {
      let prioritList =
        this.userBu == "PWB" || this.userBu == "PBL" || this.userBu == "OFM"
          ? listPriority_CN
          : [listPriority_CN[1]];
      for (const [index, item] of prioritList.entries()) {
        const header = {
          source_connection: item.flag,
        };
        const response = await this.apiservice._post(
          this.apiservice.apiUrl + this.apiservice.searchCreditNote,
          _reqBody,
          header
        );
        if (response.statusCode === 200 || response.statusCode === 201) {
          console.log("post api /searchCreditNote response : ", response);
          _setStorage(STORAGE.sourceConnectionCreditNote, header);
          if (this.Active === 3) {
            if (response.statusCode == 200) {
              window.localStorage.isOldAbb = "Y";
              _setStorage(STORAGE.searchCreditNode, {
                request: _reqBody,
                response: response.data,
              });

              this.router.navigate(["/credit-note-tax-list"]);
            } else if (response.statusCode == 201) {
              this.alert = await this.alertCtrl.create({
                subHeader: response.statusMessage,
                inputs: [
                  {
                    name: "cn_cid",
                    type: "text",
                    max: 13,
                    placeholder: "ระบุ : เลขที่ประจำตัวผู้เสียภาษี",
                  },
                ],
                buttons: [
                  {
                    text: "ย้อนกลับ",
                    cssClass: "alertCancel",
                  },
                  {
                    text: "ยืนยัน",
                    cssClass: "alertCancel",
                    handler: async (d) => {
                      let _reqBodyWithId = {
                        ..._reqBody,
                        cn_cid: d.cn_cid,
                      };

                      console.log("data reqbody cardid.....", _reqBodyWithId);

                      try {
                        this.apiservice
                          ._post(
                            this.apiservice.apiUrl +
                              this.apiservice.searchCreditNote,
                            _reqBodyWithId,
                            header
                          )

                          .then((res: any) => {
                            console.log(
                              "_getStorage(STORAGE.listdataCreditnote)=====: ",
                              res
                            );
                            if (res.statusCode == 201) {
                              window.localStorage.isOldAbb = "N";
                              _setStorage(STORAGE.searchCreditNode, {
                                request: _reqBodyWithId,
                                response: res.data,
                              });
                              this.router.navigate(["/credit-note-tax-list"]);
                            } else {
                              this.manualAlert(res.statusMessage);
                            }
                          });
                      } catch (error) {}
                    },
                  },
                ],
              });
              await this.alert.present();
            } else {
              await this.manualAlert(response.statusMessage);
            }
          } else {
            if (response.statusCode == 200) {
              window.localStorage.isOldAbb = "Y";
              _setStorage(STORAGE.searchCreditNode, {
                request: _reqBody,
                response: response.data,
              });

              this.router.navigate(["/credit-note-tax-list"], {
                queryParams: { noName: "no_cn", selectedIndex: "4" },
              });
            } else if (response.statusCode == 201) {
              this.alert = await this.alertCtrl.create({
                subHeader: response.statusMessage,
                inputs: [
                  {
                    name: "company_name",
                    type: "text",
                    placeholder: "ระบุ : ชื่อ-นามสกุล ผู้ซื้อ",
                  },
                ],
                buttons: [
                  {
                    text: "ย้อนกลับ",
                    cssClass: "alertCancel",
                  },
                  {
                    text: "ยืนยัน",
                    cssClass: "alertCancel",
                    handler: async (d) => {
                      let _reqBodyCnNoTaxId = {
                        ..._reqBody,
                        cn_cid: "",
                        cn_mode: "CNNOTAXID",
                        company_name: d.company_name,
                      };

                      console.log(
                        "data reqbody cn NOTAXID .....",
                        _reqBodyCnNoTaxId
                      );

                      try {
                        this.apiservice
                          ._post(
                            this.apiservice.apiUrl +
                              this.apiservice.searchCreditNote,
                            _reqBodyCnNoTaxId,
                            header
                          )
                          .then((res: any) => {
                            console.log("[----res data cardid -------]", res);
                            if (res.statusCode == 201) {
                              window.localStorage.isOldAbb = "N";
                              _setStorage(STORAGE.searchCreditNode, {
                                request: _reqBodyCnNoTaxId,
                                response: res.data,
                              });
                              this.router.navigate(["/credit-note-tax-list"], {
                                queryParams: {
                                  noName: "no_cn",
                                  selectedIndex: "4",
                                },
                              });
                            } else {
                              this.manualAlert(res.statusMessage);
                            }
                          });
                      } catch (error) {
                        // await this.manualAlert(errMsg.error);
                      }
                    },
                  },
                ],
              });
              await this.alert.present();
            } else {
              await this.manualAlert(response.statusMessage);
            }
          }
          break;
        } else if (response.statusCode === 204) {
          if (index == prioritList.length - 1) {
            this.manualAlert(response.statusMessage);
            break;
          }
          continue;
        } else {
          this.manualAlert(response.statusMessage);
          break;
        }
      }
    } catch (error) {}
  }

  validateSearchField() {
    let result = {
      status: true,
      message: "",
    };

    if (this.taxNumber === "") {
      result.status = false;
      result.message = "กรุณากรอกเลขที่ใบกำกับภาษี";
      return result;
    } else if (this.tpno === "") {
      result.status = false;
      result.message = "กรุณากรอกเลข TpNo";
      return result;
    } else if (this.reasonCN === "") {
      result.status = false;
      result.message = "กรุณาเลือกสาเหตุการคืนสินค้า";
      return result;
    } else if (
      this.taxNumber == "" &&
      this.identityNumber == "" &&
      this.reasonCN == ""
    ) {
      result.status = false;
      result.message = "กรุณากรอกข้อมูลให้ครบถ้วน";
      return result;
    } else if (this.reasonCN == "CDNG06" && this.remark == "") {
      result.status = false;
      result.message = "กรุณาระบุสาเหตุการคืนสินค้า";
      return result;
    } else if (this.reasonCN != "CDNG06") {
      this.remark = "";
      return result;
    }

    return result;
  }

  async manualAlert(message: string) {
    this.alert = await this.alertCtrl.create({
      cssClass: "my-custom-class",
      subHeader: message,
      buttons: [
        {
          text: "OK",
          cssClass: "alertButton",
          handler: (blah) => {
            console.log("Confirm Cancel: blah");
          },
        },
      ],
    });
    await this.alert.present();
  }

  checkNumericField(type: string) {
    switch (type) {
      case "T":
        break;
      case "I":
        if (!isNaN(this.identityNumber) && this.identityNumber.length > 13) {
          this.identityNumber = this.identityNumber.slice(0, -1);
        }
        break;
    }
  }

  displayIdentityType() {
    let displayValue = "";
    let isChar =
      this.identityNumber != ""
        ? isNaN(this.identityNumber)
          ? "CHAR"
          : "NUM"
        : "EMPTY";
    switch (isChar) {
      case "CHAR":
        displayValue = "เลขที่หนังสือเดินทาง";
        break;
      case "NUM":
        displayValue = "เลขที่บัตรประชาชน/เลขที่ประจำตัวผู้เสียภาษี";
        break;
      default:
        displayValue =
          "เลขที่บัตรประชาชน/เลขที่ประจำตัวผู้เสียภาษี/เลขที่หนังสือเดินทาง";
        break;
    }
    return displayValue;
  }
}
